module.exports = __webpack_public_path__ + "static/images/MIDAS-MOBILE-logo_txcz.58b5fea.png";